export default __webpack_public_path__ + "static/media/sunny.fcb9a87f.mp4";